var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_c('ol-map',{ref:"ol-map",attrs:{"zoom":17}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }